import styled from "styled-components";
import { DynamicHeading } from "../DynamicHeading/DynamicHeading";

export type HeadingConfig = {
  titleTag?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
} & React.HTMLAttributes<HTMLHeadingElement>;

export const Heading = styled(DynamicHeading).attrs<HeadingConfig>(
  ({ titleTag = "h1" }) => ({
    titleTag,
    as: titleTag,
  })
)<HeadingConfig>`
  font-family: var(--typography-heading-font-family);
  font-weight: var(--typography-heading-font-weight);
  font-size: var(--typography-heading-font-size-desktop);
  line-height: var(--typography-heading-line-height);
  letter-spacing: var(--typography-heading-letter-spacing);

  @media (max-width: 768px) {
    font-size: var(--typography-heading-font-size-mobile);
  }

  margin: 0;
  word-wrap: break-word;
  overflow-wrap: anywhere;
`;
